// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.epw-who-page {
  --epw-red: var(--primary);
  --epw-red-dark: var(--primary-hover);
  --epw-ink: var(--text-primary);
  --epw-muted: var(--text-secondary);
  --epw-line: var(--border);
  --epw-soft: var(--hover);
  --epw-white: var(--card-bg);
  --epw-max-width: 1120px;
  --epw-radius: 18px;
  --epw-band-bg: var(--surface-dark);
  --epw-shadow: 0 10px 30px var(--shadow);
}


    .epw-who-page, .epw-who-page * { box-sizing: border-box; }

    .epw-who-page {
      font-family:
        Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont,
        "Segoe UI", sans-serif;
      color: var(--epw-ink);
      background: var(--epw-white);
      line-height: 1.65;
    }

    .epw-who-page {
      width: 100%;
    }

    .epw-wrap {
      width: min(100%, var(--epw-max-width));
      margin: 0 auto;
    }

    .epw-hero {
      padding: 78px 24px 72px;
      background:
        radial-gradient(circle at 82% 18%, rgba(200,16,46,.12), transparent 30%),
        linear-gradient(180deg, #fafbfc 0%, #ffffff 100%);
      border-bottom: 1px solid var(--epw-line);
    }

    .epw-eyebrow {
      margin: 0 0 12px;
      color: var(--epw-red);
      font-size: .8rem;
      font-weight: 800;
      letter-spacing: .12em;
      text-transform: uppercase;
    }

    .epw-hero h1 {
      margin: 0;
      max-width: 860px;
      font-size: clamp(2.4rem, 5vw, 4.4rem);
      line-height: 1.05;
      letter-spacing: -.04em;
    }

    .epw-hero p {
      max-width: 820px;
      margin: 22px 0 0;
      color: var(--epw-muted);
      font-size: clamp(1.06rem, 2vw, 1.23rem);
    }

    .epw-main {
      padding: 60px 24px 78px;
    }

    .epw-intro {
      display: grid;
      grid-template-columns: .9fr 1.1fr;
      gap: 48px;
      align-items: start;
      margin-bottom: 54px;
    }

    .epw-intro h2,
    .epw-section-head h2 {
      margin: 0;
      font-size: clamp(1.8rem, 3vw, 2.6rem);
      line-height: 1.15;
      letter-spacing: -.03em;
    }

    .epw-intro-copy p {
      margin: 0 0 16px;
      color: var(--epw-muted);
      font-size: 1.03rem;
    }

    .epw-intro-copy p:last-child {
      margin-bottom: 0;
    }

    .epw-company-band {
      margin: 0 0 58px;
      padding: 32px;
      border-radius: 20px;
      background: var(--epw-band-bg);
      color: #ffffff;
      display: grid;
      grid-template-columns: .8fr 1.2fr;
      gap: 30px;
      align-items: center;
    }

    .epw-company-band h2 {
      margin: 0;
      font-size: clamp(1.6rem, 3vw, 2.3rem);
      line-height: 1.15;
      letter-spacing: -.03em;
    }

    .epw-company-band p {
      margin: 0;
      color: #d7dce5;
    }

    .epw-section-head {
      max-width: 760px;
      margin-bottom: 24px;
    }

    .epw-section-head p {
      margin: 12px 0 0;
      color: var(--epw-muted);
    }

    .epw-office-grid {
      display: grid;
      grid-template-columns: repeat(4, minmax(0,1fr));
      gap: 16px;
      margin-bottom: 58px;
    }

    .epw-office-card {
      border: 1px solid var(--epw-line);
      border-radius: var(--epw-radius);
      padding: 22px;
      background: var(--epw-white);
      box-shadow: var(--epw-shadow);
    }

    .epw-office-card span {
      display: inline-block;
      margin-bottom: 12px;
      color: var(--epw-red);
      font-size: .75rem;
      font-weight: 800;
      letter-spacing: .08em;
      text-transform: uppercase;
    }

    .epw-office-card h3 {
      margin: 0 0 7px;
      font-size: 1.2rem;
    }

    .epw-office-card p {
      margin: 0;
      color: var(--epw-muted);
      font-size: .94rem;
    }

    .epw-team-grid {
      display: grid;
      grid-template-columns: repeat(3, minmax(0,1fr));
      gap: 18px;
    }

    .epw-team-card {
      border: 1px solid var(--epw-line);
      border-radius: var(--epw-radius);
      padding: 24px;
      background: var(--epw-soft);
    }

    .epw-team-card h3 {
      margin: 0 0 9px;
      font-size: 1.18rem;
    }

    .epw-team-card p {
      margin: 0;
      color: var(--epw-muted);
      font-size: .95rem;
    }

    .epw-closing {
      margin-top: 56px;
      padding: 30px;
      border: 1px solid var(--epw-line);
      border-radius: 18px;
      text-align: center;
    }

    .epw-closing strong {
      display: block;
      font-size: clamp(1.35rem, 2.5vw, 1.95rem);
      margin-bottom: 8px;
    }

    .epw-closing p {
      margin: 0 auto;
      max-width: 760px;
      color: var(--epw-muted);
    }

    @media (max-width: 900px) {
      .epw-intro,
      .epw-company-band {
        grid-template-columns: 1fr;
      }

      .epw-office-grid {
        grid-template-columns: repeat(2, minmax(0,1fr));
      }

      .epw-team-grid {
        grid-template-columns: 1fr;
      }
    }

    @media (max-width: 620px) {
      .epw-hero {
        padding: 54px 20px 50px;
      }

      .epw-main {
        padding: 42px 18px 60px;
      }

      .epw-office-grid {
        grid-template-columns: 1fr;
      }

      .epw-company-band,
      .epw-office-card,
      .epw-team-card,
      .epw-closing {
        padding: 22px;
      }
    }
  `, "",{"version":3,"sources":["webpack://./src/pages/WhoWeArePage.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,uCAAuC;AACzC;;;IAGI,iCAAiC,sBAAsB,EAAE;;IAEzD;MACE;;8BAEwB;MACxB,qBAAqB;MACrB,4BAA4B;MAC5B,iBAAiB;IACnB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,sCAAsC;MACtC,cAAc;IAChB;;IAEA;MACE,uBAAuB;MACvB;;yDAEmD;MACnD,wCAAwC;IAC1C;;IAEA;MACE,gBAAgB;MAChB,qBAAqB;MACrB,gBAAgB;MAChB,gBAAgB;MAChB,qBAAqB;MACrB,yBAAyB;IAC3B;;IAEA;MACE,SAAS;MACT,gBAAgB;MAChB,qCAAqC;MACrC,iBAAiB;MACjB,sBAAsB;IACxB;;IAEA;MACE,gBAAgB;MAChB,gBAAgB;MAChB,uBAAuB;MACvB,uCAAuC;IACzC;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,aAAa;MACb,iCAAiC;MACjC,SAAS;MACT,kBAAkB;MAClB,mBAAmB;IACrB;;IAEA;;MAEE,SAAS;MACT,qCAAqC;MACrC,iBAAiB;MACjB,sBAAsB;IACxB;;IAEA;MACE,gBAAgB;MAChB,uBAAuB;MACvB,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,cAAc;MACd,aAAa;MACb,iCAAiC;MACjC,SAAS;MACT,mBAAmB;IACrB;;IAEA;MACE,SAAS;MACT,qCAAqC;MACrC,iBAAiB;MACjB,sBAAsB;IACxB;;IAEA;MACE,SAAS;MACT,cAAc;IAChB;;IAEA;MACE,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,uBAAuB;IACzB;;IAEA;MACE,aAAa;MACb,+CAA+C;MAC/C,SAAS;MACT,mBAAmB;IACrB;;IAEA;MACE,iCAAiC;MACjC,gCAAgC;MAChC,aAAa;MACb,4BAA4B;MAC5B,6BAA6B;IAC/B;;IAEA;MACE,qBAAqB;MACrB,mBAAmB;MACnB,qBAAqB;MACrB,iBAAiB;MACjB,gBAAgB;MAChB,qBAAqB;MACrB,yBAAyB;IAC3B;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,SAAS;MACT,uBAAuB;MACvB,iBAAiB;IACnB;;IAEA;MACE,aAAa;MACb,+CAA+C;MAC/C,SAAS;IACX;;IAEA;MACE,iCAAiC;MACjC,gCAAgC;MAChC,aAAa;MACb,2BAA2B;IAC7B;;IAEA;MACE,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,SAAS;MACT,uBAAuB;MACvB,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;MAChB,aAAa;MACb,iCAAiC;MACjC,mBAAmB;MACnB,kBAAkB;IACpB;;IAEA;MACE,cAAc;MACd,yCAAyC;MACzC,kBAAkB;IACpB;;IAEA;MACE,cAAc;MACd,gBAAgB;MAChB,uBAAuB;IACzB;;IAEA;MACE;;QAEE,0BAA0B;MAC5B;;MAEA;QACE,+CAA+C;MACjD;;MAEA;QACE,0BAA0B;MAC5B;IACF;;IAEA;MACE;QACE,uBAAuB;MACzB;;MAEA;QACE,uBAAuB;MACzB;;MAEA;QACE,0BAA0B;MAC5B;;MAEA;;;;QAIE,aAAa;MACf;IACF","sourcesContent":[".epw-who-page {\n  --epw-red: var(--primary);\n  --epw-red-dark: var(--primary-hover);\n  --epw-ink: var(--text-primary);\n  --epw-muted: var(--text-secondary);\n  --epw-line: var(--border);\n  --epw-soft: var(--hover);\n  --epw-white: var(--card-bg);\n  --epw-max-width: 1120px;\n  --epw-radius: 18px;\n  --epw-band-bg: var(--surface-dark);\n  --epw-shadow: 0 10px 30px var(--shadow);\n}\n\n\n    .epw-who-page, .epw-who-page * { box-sizing: border-box; }\n\n    .epw-who-page {\n      font-family:\n        Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont,\n        \"Segoe UI\", sans-serif;\n      color: var(--epw-ink);\n      background: var(--epw-white);\n      line-height: 1.65;\n    }\n\n    .epw-who-page {\n      width: 100%;\n    }\n\n    .epw-wrap {\n      width: min(100%, var(--epw-max-width));\n      margin: 0 auto;\n    }\n\n    .epw-hero {\n      padding: 78px 24px 72px;\n      background:\n        radial-gradient(circle at 82% 18%, rgba(200,16,46,.12), transparent 30%),\n        linear-gradient(180deg, #fafbfc 0%, #ffffff 100%);\n      border-bottom: 1px solid var(--epw-line);\n    }\n\n    .epw-eyebrow {\n      margin: 0 0 12px;\n      color: var(--epw-red);\n      font-size: .8rem;\n      font-weight: 800;\n      letter-spacing: .12em;\n      text-transform: uppercase;\n    }\n\n    .epw-hero h1 {\n      margin: 0;\n      max-width: 860px;\n      font-size: clamp(2.4rem, 5vw, 4.4rem);\n      line-height: 1.05;\n      letter-spacing: -.04em;\n    }\n\n    .epw-hero p {\n      max-width: 820px;\n      margin: 22px 0 0;\n      color: var(--epw-muted);\n      font-size: clamp(1.06rem, 2vw, 1.23rem);\n    }\n\n    .epw-main {\n      padding: 60px 24px 78px;\n    }\n\n    .epw-intro {\n      display: grid;\n      grid-template-columns: .9fr 1.1fr;\n      gap: 48px;\n      align-items: start;\n      margin-bottom: 54px;\n    }\n\n    .epw-intro h2,\n    .epw-section-head h2 {\n      margin: 0;\n      font-size: clamp(1.8rem, 3vw, 2.6rem);\n      line-height: 1.15;\n      letter-spacing: -.03em;\n    }\n\n    .epw-intro-copy p {\n      margin: 0 0 16px;\n      color: var(--epw-muted);\n      font-size: 1.03rem;\n    }\n\n    .epw-intro-copy p:last-child {\n      margin-bottom: 0;\n    }\n\n    .epw-company-band {\n      margin: 0 0 58px;\n      padding: 32px;\n      border-radius: 20px;\n      background: var(--epw-band-bg);\n      color: #ffffff;\n      display: grid;\n      grid-template-columns: .8fr 1.2fr;\n      gap: 30px;\n      align-items: center;\n    }\n\n    .epw-company-band h2 {\n      margin: 0;\n      font-size: clamp(1.6rem, 3vw, 2.3rem);\n      line-height: 1.15;\n      letter-spacing: -.03em;\n    }\n\n    .epw-company-band p {\n      margin: 0;\n      color: #d7dce5;\n    }\n\n    .epw-section-head {\n      max-width: 760px;\n      margin-bottom: 24px;\n    }\n\n    .epw-section-head p {\n      margin: 12px 0 0;\n      color: var(--epw-muted);\n    }\n\n    .epw-office-grid {\n      display: grid;\n      grid-template-columns: repeat(4, minmax(0,1fr));\n      gap: 16px;\n      margin-bottom: 58px;\n    }\n\n    .epw-office-card {\n      border: 1px solid var(--epw-line);\n      border-radius: var(--epw-radius);\n      padding: 22px;\n      background: var(--epw-white);\n      box-shadow: var(--epw-shadow);\n    }\n\n    .epw-office-card span {\n      display: inline-block;\n      margin-bottom: 12px;\n      color: var(--epw-red);\n      font-size: .75rem;\n      font-weight: 800;\n      letter-spacing: .08em;\n      text-transform: uppercase;\n    }\n\n    .epw-office-card h3 {\n      margin: 0 0 7px;\n      font-size: 1.2rem;\n    }\n\n    .epw-office-card p {\n      margin: 0;\n      color: var(--epw-muted);\n      font-size: .94rem;\n    }\n\n    .epw-team-grid {\n      display: grid;\n      grid-template-columns: repeat(3, minmax(0,1fr));\n      gap: 18px;\n    }\n\n    .epw-team-card {\n      border: 1px solid var(--epw-line);\n      border-radius: var(--epw-radius);\n      padding: 24px;\n      background: var(--epw-soft);\n    }\n\n    .epw-team-card h3 {\n      margin: 0 0 9px;\n      font-size: 1.18rem;\n    }\n\n    .epw-team-card p {\n      margin: 0;\n      color: var(--epw-muted);\n      font-size: .95rem;\n    }\n\n    .epw-closing {\n      margin-top: 56px;\n      padding: 30px;\n      border: 1px solid var(--epw-line);\n      border-radius: 18px;\n      text-align: center;\n    }\n\n    .epw-closing strong {\n      display: block;\n      font-size: clamp(1.35rem, 2.5vw, 1.95rem);\n      margin-bottom: 8px;\n    }\n\n    .epw-closing p {\n      margin: 0 auto;\n      max-width: 760px;\n      color: var(--epw-muted);\n    }\n\n    @media (max-width: 900px) {\n      .epw-intro,\n      .epw-company-band {\n        grid-template-columns: 1fr;\n      }\n\n      .epw-office-grid {\n        grid-template-columns: repeat(2, minmax(0,1fr));\n      }\n\n      .epw-team-grid {\n        grid-template-columns: 1fr;\n      }\n    }\n\n    @media (max-width: 620px) {\n      .epw-hero {\n        padding: 54px 20px 50px;\n      }\n\n      .epw-main {\n        padding: 42px 18px 60px;\n      }\n\n      .epw-office-grid {\n        grid-template-columns: 1fr;\n      }\n\n      .epw-company-band,\n      .epw-office-card,\n      .epw-team-card,\n      .epw-closing {\n        padding: 22px;\n      }\n    }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
